// extracted by mini-css-extract-plugin
export default {"main":"Button_main__PHIes","small":"Button_small__eMeMu","white":"Button_white__ZSRfm","disabled":"Button_disabled__EpUeO"};